import { getMarket, getMarketByName } from './markets'

// Price formatting for market-aware surfaces. Uses each market's local
// convention rather than Intl's default symbol, because Intl renders MYR as
// "MYR 89.24" in en-MY on some runtimes while Malaysians write "RM89.24", and
// SGD as "SGD 47.84" where the site has always shown "$47.84".
//
//   formatMoney(119.6, 'ae')        -> "AED 119.60"
//   formatMoney(89.24, 'my')        -> "RM89.24"
//   formatMoney(47.84, 'sg')        -> "$47.84"
//   formatMoney(179, 'ae', 0)       -> "AED 179"
export const formatMoney = (amount, countryCd, fractionDigits = 2) => {
    const market = getMarket(countryCd)
    const value = Number(amount)
    if (!Number.isFinite(value)) return ''
    const number = value.toLocaleString('en-US', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })
    return `${market.currencyPrefix}${number}`
}

// The two halves of formatMoney, for narrow price tiles that put the currency
// on its own line: formatAmount(1188.64, 'ae') -> "1,188.64",
// currencyLabel('ae') -> "AED", currencyLabel('my') -> "RM".
export const formatAmount = (amount, countryCd, fractionDigits = 2) => {
    const value = Number(amount)
    if (!Number.isFinite(value)) return ''
    return value.toLocaleString('en-US', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })
}
export const currencyLabel = (countryCd) => getMarket(countryCd).currencyPrefix.trim()

// Same, keyed by currency code - for components that only receive
// `currencyCd` from the backend (cost breakdowns, receipts).
export const formatMoneyByCurrency = (amount, currencyCd, fractionDigits = 2) => {
    const byCurrency = { SGD: 'sg', AED: 'ae', MYR: 'my' }
    const cd = byCurrency[(currencyCd || '').toUpperCase()]
    if (cd) return formatMoney(amount, cd, fractionDigits)
    const value = Number(amount)
    if (!Number.isFinite(value)) return ''
    return `${currencyCd || ''} ${value.toFixed(fractionDigits)}`.trim()
}

export const currencyPrefixFor = (countryName) =>
    (getMarketByName(countryName) ?? getMarket('sg')).currencyPrefix

// "AED 70-100", "$35-50", "RM50-75": the currency once, for pay ranges.
export const formatMoneyRangeByCurrency = (min, max, currencyCd) => {
    const high = Number(max)
    if (!Number.isFinite(high) || Number(min) === high) return formatMoneyByCurrency(min, currencyCd, 0)
    return `${formatMoneyByCurrency(min, currencyCd, 0)}–${high.toLocaleString('en-US')}`
}
